import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';

@Component({
    selector: 'common-ui-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterViewInit {

    @ViewChild('uebersichtFooter') uebersichtFooter;

    @Input()
    public extraCss: string;
    public readonly imprintLink = 'https://go.datev.de/impressum-os-eg';

    public readonly privacyLink = 'https://go.datev.de/dsgvo-information';

    public ngAfterViewInit(): void {
        const doc = document.documentElement;
        const uebersichtFooter = this.uebersichtFooter.nativeElement.offsetHeight;
        doc.style.setProperty('--uebersicht-footer-height', `${uebersichtFooter}px`);
    }
}
